module.exports = __webpack_public_path__ + "static/carly-77bf2ba46c7c22c633154a60bfbf07b7.png";